<div
  class="calendly-modal-backdrop"
  (click)="onBackdropClick($event)"
>
  <div class="calendly-modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="fw-semibold m-0">
        Prenota una sessione con {{ caregiver?.info?.name }}
        {{ caregiver?.info?.surname }}
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Chiudi"
        (click)="closeModal()"
      ></button>
    </div>

    <!-- Calendly Component -->
    <div *ngIf="caregiver?.info?.calendarLink" class="w-100">
      <app-calendly
        [url]="caregiver!.info.calendarLink!"
        (scheduled)="onScheduled($event)"
      ></app-calendly>
    </div>

    <!-- Fallback se non c'è link calendario -->
    <div *ngIf="!caregiver?.info?.calendarLink" class="text-center py-4">
      <p class="text-muted">
        Link calendario non disponibile per questo psicologo.
      </p>
    </div>
  </div>
</div>
